/**
 * Scanner im Verkauf: wann ein Scan in den Bon darf. Während einer Zahlung darf sich
 * der Bon nicht ändern – sonst laufen Betrag am Terminal, Kundenanzeige und Beleg
 * auseinander. Ein gesperrter Scan wird verworfen (nicht nachgeholt) und gemeldet;
 * die Kassierkraft scannt nach dem Abschluss erneut.
 */
export interface VerkaufsZustand {
  /** Beleg wird gerade erstellt (Netzaufruf läuft). */
  laeuft: boolean;
  /** Kartenzahlung am Terminal läuft (Zahlungsdialog offen). */
  kartenzahlung: boolean;
  /** Trinkgeldabfrage vor der Kartenzahlung offen. */
  trinkgeldFrage: boolean;
  /** Bar-Dialog (Gegeben/Rückgeld) offen. */
  barDialog: boolean;
  /** Ungeklärte Zahlung, ungeklärter Kartenstart oder ungeklärter Beleg. */
  vorgangOffen: boolean;
  /** Positionen sind für eine Zahlung festgehalten. */
  positionenFest: boolean;
  /** Beleg bzw. vorläufiger Offline-Beleg wird angezeigt (Bon im Hintergrund unsichtbar). */
  belegOffen: boolean;
}

/** Grund, warum gerade kein Scan in den Bon darf – sonst null. */
export function scanSperre(z: VerkaufsZustand): string | null {
  if (z.kartenzahlung || z.trinkgeldFrage) {
    return 'Kartenzahlung läuft';
  }
  if (z.laeuft) {
    return 'Beleg wird erstellt';
  }
  if (z.barDialog) {
    return 'Barzahlung offen';
  }
  if (z.vorgangOffen || z.positionenFest) {
    return 'Zahlung oder Beleg ungeklärt – erst „Zahlung prüfen“';
  }
  if (z.belegOffen) {
    return 'Beleg noch offen – erst „Neuer Verkauf“';
  }
  return null;
}

/**
 * H4 (Folge aus PB-1): Felder mit `data-scansperre` (Betragsfelder in Dialogen, z. B. Gutschein
 * „Betrag €“/„Einlösen €“) nehmen nie einen Scan als Wert an – wie „Gegeben“ im Bar-Dialog.
 * Liefert den Sperrgrund oder `null`.
 */
export function feldScanSperre(feld: HTMLElement): string | null {
  // Go-Live: Passwort-, PIN- und Einmalcodefelder nehmen nie einen Scan an (Feld zurück, Hinweis)
  if (
    'type' in feld &&
    (feld.type === 'password' ||
      ('autocomplete' in feld &&
        typeof feld.autocomplete === 'string' &&
        /(^|\s)(one-time-code|current-password|new-password)$/.test(feld.autocomplete)))
  ) {
    return 'Passwort- bzw. Codefeld';
  }
  const grund = feld.dataset.scansperre;
  if (grund === undefined) {
    return null;
  }
  return grund === '' ? 'Betragsfeld' : grund;
}

/** Meldung zu einem verworfenen Scan. */
export function gesperrterScan(code: string, grund: string): string {
  return `Scan ${code} nicht übernommen: ${grund}`;
}
